export default {
	name: "bulk-credit-top-up-modal",
	props: ["showModal"],
	emits: ["modalClose"],
	data() {
		return {
			modalHeading: "Bulk Top Ups",
			modalComponentId: "bulkCreditTopUpModal",
			currentStep: 1,
			selectedFile: null,
			loading: false,
			bulkCreditsTopUps: [],
			successfulTopUps: [],
			failedTopUps: [],
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			verifyDataHeadings: [
				{
					text: "Company",
					field: "customerName"
				},
				// {
				// 	text: "Customer Code", 
				// 	field: "customerCode"
				// },
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "Top Up Value",
					field: "topValue"
				},
				{
					text: "Date of Payment",
					field: "paymentDate"
				},
				// {
				// 	text: "Invoice Number",
				// 	field: "invoiceNumber"
				// }
			],
			resultsHeadings: [
				{
					text: "Company",
					field: "customerName"
				},
				// {
				// 	text: "Customer Code",
				// 	field: "customerCode"
				// },
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "Top Up Value",
					field: "topValue"
				},
				{
					text: "Date of Payment",
					field: "paymentDate"
				},
				// {
				// 	text: "Invoice Number",
				// 	field: "invoiceNumber"
				// }
			],
			failedResultsHeadings: [
				{
					text: "Company",
					field: "customerName"
				},
				// {
				// 	text: "Customer Code",
				// 	field: "customerCode"
				// },
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "Top Up Value",
					field: "topValue"
				},
				{
					text: "Date of Payment",
					field: "paymentDate"
				},
				// {
				// 	text: "Invoice Number",
				// 	field: "invoiceNumber"
				// },
				{
					text: "Reason for Failure",
					field: "reasonForFailure"
				}
			]
		};
	},
	watch: {
        showModal: {
            handler: function (){
                if (this.showModal) {
                    this.resetModal();
                    $("#" + this.modalComponentId).modal("show");
                } else {
                    $("#" + this.modalComponentId).modal("hide");
                }
            },
            immediate: true,
            deep: true
        }
	},
	methods: {
		resetModal() {
			this.currentStep = 1;
			this.selectedFile = null;
			this.bulkCreditsTopUps = [];
			this.successfulTopUps = [];
			this.failedTopUps = [];
			this.clearMessageAlerts();
		},
		clearMessageAlerts() {
			this.showSuccessMessage = false;
			this.successMessage = null;
			this.showErrorMessage = false;
			this.errorMessage = null;
		},
		onFileSelect(event) {
			const file = event.target.files[0];
			if (file) {
				if (this.validateFile(file)) {
					this.selectedFile = file;
				}
			}
		},
		onFileDrop(event) {
			event.preventDefault();
			event.target.classList.remove('dragover');
			const files = event.dataTransfer.files;
			if (files.length > 0) {
				const file = files[0];
				if (this.validateFile(file)) {
					this.selectedFile = file;
				}
			}
		},
		onDragOver(event) {
			event.preventDefault();
			event.target.classList.add('dragover');
		},
		onDragLeave(event) {
			event.preventDefault();
			event.target.classList.remove('dragover');
		},
		validateFile(file) {
			// Check file type
			const validTypes = [
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
				'application/vnd.ms-excel' // .xls
			];
			
			if (!validTypes.includes(file.type)) {
				this.showErrorMessage = true;
				this.errorMessage = "Please select a valid Excel file (.xlsx or .xls).";
				return false;
			}
			
			// Check file size (limit to 10MB)
			const maxSize = 10 * 1024 * 1024; // 10MB
			if (file.size > maxSize) {
				this.showErrorMessage = true;
				this.errorMessage = "File size must be less than 10MB.";
				return false;
			}
			
			this.clearMessageAlerts();
			return true;
		},
		formatFileSize(bytes) {
			if (bytes === 0) return '0 Bytes';
			const k = 1024;
			const sizes = ['Bytes', 'KB', 'MB', 'GB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
		},
		uploadFile() {
			if (!this.selectedFile) {
				this.showErrorMessage = true;
				this.errorMessage = "Please select a file to upload.";
				return;
			}

			this.loading = true;
			this.clearMessageAlerts();

			// Create FormData to send the file to the endpoint
			const formData = new FormData();
			formData.append('file', this.selectedFile);

			// Send the file directly to the AddOrUpdateBulkCreditsTopUps endpoint
			customerCreditsService.addOrUpdateBulkCreditsTopUps(formData)
				.then(successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(
						successResponse.data.responseStatus, 
						successResponse.data.httpStatusCode, 
						successResponse.data.message
					);
					if (isSuccess) {
						this.bulkCreditsTopUps = successResponse.data.bulkCreditsTopUps || [];
						if (this.bulkCreditsTopUps.length === 0) {
							this.showErrorMessage = true;
							this.errorMessage = "No valid records found in the uploaded file.";
						} else {
							this.currentStep = 2;
						}
					} else {
						this.showErrorMessage = true;
						this.errorMessage = successResponse.data.message || "Failed to process file.";
					}
					this.loading = false;
				})
				.catch(errorResponse => {
					console.log("error", errorResponse);
					this.showErrorMessage = true;
					this.errorMessage = errorResponse.message || "Failed to upload file. Please try again.";
					this.loading = false;
					if (errorResponse.response) {
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				});
		},
		finalizeTopUp() {
			this.loading = true;
			this.clearMessageAlerts();

			const request = {
				bulkCreditTopUpRequests: this.bulkCreditsTopUps,
				//instanceId: guidHelper.generateGuid()
			};

			customerCreditsService.topUpCreditsInBulk(request)
				.then(successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(
						successResponse.data.responseStatus,
						successResponse.data.httpStatusCode,
						successResponse.data.message
					);
					if (isSuccess) {
						const results = successResponse.data.bulkCreditsTopUpResponses || [];
						this.successfulTopUps = results.filter(item => item.topUpSuccessful);
						this.failedTopUps = results.filter(item => !item.topUpSuccessful);
						this.currentStep = 3;
					} else {
						this.showErrorMessage = true;
						this.errorMessage = successResponse.data.message || "Failed to process bulk top-up.";
					}
					this.loading = false;
				})
				.catch(errorResponse => {
					console.log("error", errorResponse);
					this.showErrorMessage = true;
					this.errorMessage = errorResponse.message || "Failed to process bulk top-up. Please try again.";
					this.loading = false;
					if (errorResponse.response) {
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				});
		},
		goToPreviousStep() {
			if (this.currentStep > 1) {
				this.currentStep--;
			}
		},
		onModalCloseClick() {
            console.log("modal closed");
			$("#" + this.modalComponentId).modal("hide");
			this.$emit("modalClose");
		}
	},
	mounted: function () {
		// Modal event handlers
		$("#" + this.modalComponentId).on("hidden.bs.modal", () => {
            console.log("modal closed");
			//this.$emit("modalClose");
		});
	}
};